import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Layout, Row, Col } from "antd";
import { Redirect } from "react-router-dom";
import Sidebar from "./components/menu/Sidebar";
import MenuHeader from "./components/header";
// Note: Firebase messaging imports removed - handled in App.jsx to prevent duplicates

const { Content } = Layout;

export default function VerticalLayout(props) {
  const { children } = props;
  const [visible, setVisible] = useState(false);
  // Redux
  const customise = useSelector((state) => state.customise);
  const auth = useSelector((state) => state.login);
  const isAuthenticated = localStorage.getItem("authenticated");

  useEffect(() => {
    // Note: FCM Token request and message listener moved to App.jsx
    // to prevent duplicate listeners when VerticalLayout remounts on navigation

    // Only keep layout-specific logic here
    // getNotificationList({ type: "web" });

    // let interval = setInterval(() => {
    //   getNotificationList({ type: "web" });
    // }, 120000);

    // return () => {
    //   if (interval) {
    //     clearInterval(interval);
    //   }
    // };
  }, []);

  useEffect(() => {
    // Function to handle logout across all tabs
    const handleStorageChange = (event) => {
      console.log(event.key + " - " + event.newValue);
      if (event.key === "authenticated" && event.newValue == null) {
        setRedirect(true);
      }
    };

    // Listen for changes in localStorage across all tabs
    window.addEventListener("storage", handleStorageChange);

    // Clean up event listener
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return isAuthenticated ? (
    <Layout className="hp-app-layout">
      <Sidebar visible={visible} setVisible={setVisible} />

      <Layout className="hp-bg-color-dark-90">
        <MenuHeader setVisible={setVisible} className="vertical_header" />

        <Content className="hp-content-main hp-mt-24">
          <Row justify="center">
            {customise.contentWidth == "full" && (
              <Col span={24}>{children}</Col>
            )}

            {customise.contentWidth == "boxed" && (
              <Col xxl={20} xl={22} span={24}>
                {children}
              </Col>
            )}
          </Row>
        </Content>
      </Layout>
    </Layout>
  ) : (
    <Redirect to="/login" />
  );
}
